import { render } from "./TalkjsTrigButton.vue?vue&type=template&id=14c90d8e&scoped=true"
import script from "./TalkjsTrigButton.vue?vue&type=script&lang=js"
export * from "./TalkjsTrigButton.vue?vue&type=script&lang=js"

import "./TalkjsTrigButton.vue?vue&type=style&index=0&id=14c90d8e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c90d8e"]])

export default __exports__